import React, { useState, useEffect, useContext } from 'react';
import { Breadcrumb, Card, Col, Row, Tabs } from "antd";
import Icofont from "react-icofont";
import { deleteInArray, errorCatch, GET, READ, uncapitalize } from '../../components/Tool';
import { Link, Route, useRouteMatch } from "react-router-dom";
import { useUserContext } from '../../components/Context';
import { useAuth } from '../../components/Auth';
import AbstractCollection from '../../components/AbstractCollection';
import CollectionServer from '../../components/CollectionServer';
import Model from '../../components/Model';
import { useSelector } from 'react-redux';

const { TabPane } = Tabs;

export default function SystemQuestions(props) {
    const auth = useAuth();
    const user = useUserContext();

    const meta = useSelector(state => state.meta);
    const name = "questions";

return (<>
        <Breadcrumb style={{ margin: '16px 16px' }}>
            <Breadcrumb.Item>Система</Breadcrumb.Item>
            <Breadcrumb.Item>Вопросы</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: 12, minHeight: 360, backgroundColor: "white", height: "100%" }}>
            <Col span={24}>
                <Card size="small" bordered={false}>
                    {meta && <CollectionServer
                        auth={auth}
                        name={name}
                        // source={"/api/query/resourcelocks"}
                        filters={() => [
                            {
                                name: "id",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "title",
                                sort: true,
                                filter: true,
                            }
                        ]}
                        columns={({ auth, collection, setCollection, request }) => [
                            {
                                key: "0",
                                title: "ID",
                                render: (text, record, index) => {
                                    return (record.ID);
                                }
                            },
                            {
                                key: "1",
                                title: "Текст",
                                render: (text, record, index) => {
                                    return (record.title);
                                }
                            }
                        ]}
                        // mode={"list"}
                        // render={(item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => (<></>)}

                        size={"small"}
                        // titleFunc={(title) => "Заказы"}
                        defaultModelActions={true}
                        defaultCollectionActions={true}
                    />}
                </Card>
            </Col>
        </div>
    </>);
}